const faqs = [
  {
    question: '亚洲精品的选品标准是什么？',
    answer: '亚洲精品实行严格的六道甄选流程：产地溯源确保原材料纯正、工艺评估验证制作水准、品质检测把关产品质量、设计评审关注审美价值、文化价值评估挖掘文化内涵、用户体验测试确保使用感受。只有通过全部六道流程的商品才能入选亚洲精品。',
  },
  {
    question: '亚洲精品的商品来源覆盖哪些地区？',
    answer: '亚洲精品的商品来源覆盖日本、韩国、中国、泰国、越南、新加坡、马来西亚、印度尼西亚等亚洲主要国家和地区。我们与各地的顶级品牌、独立设计师和传统匠人工坊建立了长期合作关系，确保商品的纯正品质和稳定供应。',
  },
  {
    question: '如何确保商品是正品？',
    answer: '亚洲精品与所有合作品牌和匠人工坊均签有正品保障协议。每件商品均附带品牌官方认证或匠人亲笔签名的品质保证书。我们还会定期派遣质检团队前往产地实地考察，确保从源头把控品质。',
  },
  {
    question: '亚洲精品的商品适合送礼吗？',
    answer: '非常适合。亚洲精品的大部分商品均配有精美的礼盒包装，同时我们提供个性化礼品定制服务，包括手写贺卡、定制包装等。无论是商务馈赠还是亲友送礼，亚洲精品都是品味之选。',
  },
  {
    question: '如何联系亚洲精品的客服团队？',
    answer: '您可以通过官方网站的"联系我们"页面提交咨询，我们的客服团队会在24小时内回复。您也可以在工作日9:00-18:00拨打客服热线：400-888-9999，或发送邮件至 service@yazhoujingpin.com。',
  },
];

export default function FAQ() {
  return (
    <section className="py-14 md:py-20 bg-background-50">
      <div className="max-w-3xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">
            常见问题
          </h2>
          <p className="mt-3 text-foreground-500 text-sm md:text-base">
            关于亚洲精品的常见疑问解答
          </p>
        </div>

        <div className="space-y-3">
          {faqs.map((faq, index) => (
            <details
              key={index}
              className="group bg-background-100 rounded-xl overflow-hidden"
            >
              <summary className="flex items-center justify-between p-4 md:p-5 cursor-pointer list-none marker:hidden">
                <h4 className="text-sm md:text-base font-medium text-foreground-900 pr-4">
                  {faq.question}
                </h4>
                <i className="ri-arrow-down-s-line w-5 h-5 flex items-center justify-center text-foreground-400 group-open:rotate-180 transition-transform duration-200 flex-shrink-0"></i>
              </summary>
              <div className="px-4 md:px-5 pb-4 md:pb-5">
                <p className="text-sm text-foreground-600 leading-relaxed">
                  {faq.answer}
                </p>
              </div>
            </details>
          ))}
        </div>
      </div>

      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'FAQPage',
            mainEntity: faqs.map((faq) => ({
              '@type': 'Question',
              name: faq.question,
              acceptedAnswer: {
                '@type': 'Answer',
                text: faq.answer,
              },
            })),
          }),
        }}
      />
    </section>
  );
}